import { FamilyChildProfile, UserRole } from "@joonapp/web-shared"
import { Family } from "@joonapp/web-shared"
import dayjs from "dayjs"

export const getChildrenFromFamily = (family: Family) => {
  return family.profiles.filter(
    (profile) => profile.role === UserRole.CHILD
  ) as FamilyChildProfile[]
}

export const sortChildrenByBirthdate = (children: FamilyChildProfile[]) => {
  return children.sort((a, b) => {
    if (!a.user.birthdate) return 1
    if (!b.user.birthdate) return -1
    return dayjs(b.user.birthdate).diff(dayjs(a.user.birthdate))
  })
}

export const getSortedChildrenFromFamily = (family: Family | undefined) => {
  if (!family) return []
  return sortChildrenByBirthdate(getChildrenFromFamily(family))
}
